import { Ui } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';
import { LoginForm } from './LoginForm';
import { useLogin } from './LoginState';

export const LoginModal = () => {
  const { showLogin, setShowLogin, isProviderStep } = useLogin();
  const t = useTranslations('features.navigationLegacy.login');

  return (
    <Ui.Overlay
      title={t('title')}
      /* That step pads itself, so it matches the mobile menu, which the
         overlay does not wrap. */
      withoutPadding={isProviderStep}
      open={showLogin}
      onClose={() => setShowLogin(false)}
    >
      <LoginForm />
    </Ui.Overlay>
  );
};
